import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import api, { fmtDateTime } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";

const typeIcon = {
  approval: [Icons.ClipboardCheck, "bg-amber-50 text-amber-600"],
  success: [Icons.CheckCircle2, "bg-emerald-50 text-emerald-600"],
  error: [Icons.XCircle, "bg-red-50 text-red-600"],
  payroll: [Icons.Wallet, "bg-blue-50 text-blue-600"],
  info: [Icons.Info, "bg-slate-100 text-slate-600"],
};

export default function Notifications() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const load = () => api.get("/notifications").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="uemp-fade-in">
      <PageHeader title="Notification Center" subtitle="All your platform alerts in one place"
        actions={<Button variant="outline" onClick={markAll} data-testid="notif-mark-all-page"><Icons.CheckCheck className="h-4 w-4 mr-1.5" /> Mark all read</Button>} />
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-testid="notifications-list">
        {items.length === 0 && <div className="p-12 text-center text-slate-400">No notifications.</div>}
        {items.map((n) => {
          const [Icon, color] = typeIcon[n.type] || typeIcon.info;
          return (
            <button key={n.id}
              onClick={async () => { await api.post(`/notifications/${n.id}/read`); load(); if (n.link) navigate(n.link); }}
              className={`w-full text-left px-5 py-4 border-b border-slate-100 last:border-0 hover:bg-slate-50 flex items-center gap-4 ${n.read ? "opacity-60" : ""}`}>
              <div className={`h-9 w-9 rounded-lg flex items-center justify-center shrink-0 ${color}`}><Icon className="h-[18px] w-[18px]" /></div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-slate-800">{n.title}</div>
                <div className="text-xs text-slate-500 truncate">{n.message}</div>
              </div>
              <div className="text-[11px] text-slate-400 shrink-0">{fmtDateTime(n.created_at)}</div>
              {!n.read && <span className="h-2 w-2 rounded-full bg-blue-600 shrink-0" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
